import { useMemo } from 'react';
import classes from 'components/widgets/ProjectSummary/cardWrapper.module.scss';
import { WidgetCard } from 'components/common';
import { maxBy, orderBy } from 'lodash';
import { getTitleColorByStatus } from 'components/widgets/ProjectSummary/ProgressCard/progressCard.utils';
import { ProgressCardMetrics } from 'components/widgets/ProjectSummary/ProgressCard/ProgressCardMetrics';
import { ToggleCollapse } from 'components/widgets/ProjectSummary/ToggleCollapse';
import { maxHeight, maxValueScale } from 'components/widgets/ProjectSummary/cardsSection.utils';
import colorsVars from 'styles/colors.module.scss';
import { useThemeStatusStore } from 'store/themeStatus.store';
import { SummaryCard } from 'api/queries/getProjectStatusScoreCards.query';
import { ProgressCardGraph } from 'components/widgets/ProjectSummary/ProgressCard/ProgressCardGraph';

interface Props extends SummaryCard {
    collapse: boolean;
    setCollapse: (value: boolean) => void;
}

export const ProgressCard = ({ cardProperties, cardTitle, cardTrends, overallScore, collapse, setCollapse }: Props) => {
    const sortedMetricsList = useMemo(() => orderBy(cardProperties.metrics, ['order', 'desc']), [cardProperties]);
    const { white } = colorsVars;
    const showGraphSection = cardTrends?.[0];
    const height = !collapse && showGraphSection ? maxHeight : '100%';
    const maxValuePoint = maxBy(cardTrends?.[0]?.graphPoints, 'score');
    const maxValue = maxValuePoint ? maxValuePoint?.score * maxValueScale : undefined;
    const status = cardTitle.status;
    const tooltipContent =
        status === 'NO DATA' ? 'No data found matching the filter' : `Overall Score is ${overallScore.value}`;
    const id = `statusSummary_progress`;

    const { themeStatus } = useThemeStatusStore();

    return (
        <WidgetCard
            titleColor={
                status === 'NO DATA' ? white : getTitleColorByStatus({ value: overallScore.value, theme: themeStatus })
            }
            titleText={cardTitle.title}
            scoreValue={status}
            contentHeight={height}
            tooltipContent={tooltipContent}
            id={id}
        >
            <div className={classes.cardWrapper}>
                <div className={classes.topSection}>
                    <div className={`${classes.metricsListContainer} ${collapse && classes.collapse}`}>
                        <ProgressCardMetrics sortedMetricsList={sortedMetricsList} id={id} />
                    </div>
                    <ToggleCollapse setCollapse={setCollapse} collapse={collapse} id={id} />
                </div>
                {showGraphSection && (
                    <ProgressCardGraph
                        data={cardTrends}
                        xaxisTitle={'Version'}
                        yaxisTitle={'Progress'}
                        yAxisMaxValue={maxValue}
                    />
                )}
            </div>
        </WidgetCard>
    );
};
